export default __webpack_public_path__ + "static/media/251037.b384104e.webp";